import { Observable } from "MWL@2026/modules/Observable/@contract/@types/def";
import { OBS_CTRLER } from "MWL@2026/modules/Observable/@contract/@types/ctrler";

/** TODO: remove... */
export class ObservableProxy<
                                This extends object|void = void,
                                Args extends any[] = []
                            > implements Observable<This, Args> {

    readonly [OBS_CTRLER]: Observable<This, Args>[OBS_CTRLER];

    constructor(target: Observable<This, Args>) {
        this[OBS_CTRLER] = target[OBS_CTRLER];
    }
}